import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Col, Form, Button, FormControl, FormGroup, ControlLabel } from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import { updateJWT } from "../../../actions/UserActions";
import UserService from "../../../services/UserService";
import handleError from "../../../services/HandleError";
import InlineError from "../../messages/InlineError";
import LoaderInline from "../../helpers/LoaderInline";
import Materialicon from "../../helpers/Materialicon";
// import { mapDispatchToProps, mapStateToProps } from "../../../RootReducer";

class UpdatePasswordForm extends Component {

    state = {
    	formData: { old_password: "", password: "", password_confirmation: "" },
    	errors: {},
    	isSaving: false
    }

    onChange = (e) => this.setState({ formData: { ...this.state.formData, [e.target.name]: e.target.value } });

    savePassword = (e) => {
    	e.preventDefault();
    	const errors = this.validate(this.state.formData);
    	const { formData } = this.state;
    	this.setState({ errors });
    	if (Object.keys(errors).length === 0) {
    		this.setState({ isSaving: true });
    		this.userService.store(formData).then((res) => {
    			// this.props.dispatch(updateJWT("GENTRITTOKEN12432432523")); // here we should pass the new token generated from API
    			this.setState({ isSaving: false, formData: { old_password: "", password: "", password_confirmation: "" } });
    			NotificationManager.success("Password updated.", "Success!");
    		}).catch((err) => {
    			handleError(err, this);
    			this.setState({ isSaving: false });
    		});
    	}
    }

    validate = (data) => {
    	const errors = {};
    	if (!data.old_password) errors.old_password = "Can't be blank";
    	if (!data.password) errors.password = "Can't be blank";
    	if (!data.password_confirmation) errors.password_confirmation = "Can't be blank";
    	if (!data.password_confirmation || (data.password !== data.password_confirmation)) errors.password_confirmation = "Password do not match";
    	return errors;
    };

    userService = new UserService(this, this.props.userLoginData.user.id, "change-password")

    render() {
    	const { errors, isSaving } = this.state;
    	const { password, password_confirmation, old_password } = this.state.formData;
    	return (
    		<div className="settings-form">
    			<Form horizontal onSubmit={this.savePassword}>
    				<FormGroup validationState={errors.old_password && "error"}>
    					<Col componentClass={ControlLabel} sm={4}>Old password</Col>
    					<Col sm={8}>
    						<FormControl minLength={6} type="password" name="old_password" value={old_password || ""} placeholder="Old password" onChange={this.onChange} />
    						{errors.old_password && <InlineError text={errors.old_password} />}
    					</Col>
    				</FormGroup>
    				<FormGroup validationState={errors.password && "error"}>
    					<Col componentClass={ControlLabel} sm={4}>New password</Col>
    					<Col sm={8}>
    						<FormControl minLength={6} type="password" name="password" value={password || ""} placeholder="New password" onChange={this.onChange} />
    						{errors.password && <InlineError text={errors.password} />}
    					</Col>
    				</FormGroup>
    				<FormGroup validationState={errors.password_confirmation && "error"}>
    					<Col componentClass={ControlLabel} sm={4}>Repeat new password</Col>
    					<Col sm={8}>
    						<FormControl minLength={6} type="password" name="password_confirmation" value={password_confirmation || ""} id="password_confirmation" placeholder="Repeat new password" onChange={this.onChange} />
    						{errors.password_confirmation && <InlineError text={errors.password_confirmation} />}
    					</Col>
    				</FormGroup>
    				<FormGroup>
    					<Col smOffset={4} sm={8}>
    						<Button type="submit" disabled={isSaving} bsStyle="primary" className="withIcon btn-crud">{isSaving?"Saving...":"Change password"}</Button>
    						{isSaving && <LoaderInline width="30" height="30" color="#2196f3"/> }
    					</Col>
    				</FormGroup>
    			</Form>
    		</div>
    	);
    }
}
UpdatePasswordForm.propTypes = {
	userLoginData: PropTypes.shape({
		user: PropTypes.shape({
			id: PropTypes.string,
			first_name: PropTypes.string,
			last_name: PropTypes.string,
			email: PropTypes.string,
			photo: PropTypes.string,
			date_of_birth: PropTypes.string
		}).isRequired
	}).isRequired,
	// dispatch: PropTypes.func.isRequired
};
const UserPageData = (state) => ({
	userLoginData: state.userLoginData,
});
export default connect(UserPageData)(UpdatePasswordForm);


// WEBPACK FOOTER //
// ./src/components/forms/users/UpdatePasswordForm.js